
<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>个人赛赛务管理</el-breadcrumb-item>
      <el-breadcrumb-item>个人赛程</el-breadcrumb-item>
      <el-breadcrumb-item>全国总决选</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>
    <!-- <el-card>
      <el-row :gutter="20">
        <el-col>
          <el-button type="primary" @click="englishNationalPlayerInfoclicked"
            >英文国赛选手信息</el-button
          >
        </el-col>
      </el-row>
    </el-card> -->

    <!--  -->
    <el-tabs v-model="activeName" type="card" @tab-click="tabHandleClick">
      <el-tab-pane label="总决选选手信息" name="0">
        <!-- 筛选 -->
        <el-card>
          <el-row class="title_row">
            <el-col>
              <span class="title_class">选手信息筛选</span>
            </el-col>
          </el-row>
          <el-form
            :model="queryForm"
            class="filter_Form"
            label-width="100px"
            ref="queryFormRef"
          >
            <el-row :gutter="50">
              <el-col :span="6">
                <el-form-item label="赛季" prop="season">
                  <el-select
                    placeholder="请选择类型"
                    style="width: 100%"
                    v-model="queryForm.season"
                  >
                    <el-option
                      v-for="item in dict_season"
                      :key="item.dictCode"
                      :label="item.dictLabel"
                      :value="item.dictValue"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="赛区" prop="districtId">
                  <el-select
                    placeholder="请选择"
                    style="width: 100%"
                    v-model="queryForm.districtId"
                  >
                    <el-option
                      v-for="item in dict_district"
                      :key="item.id"
                      :label="item.districtName"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="组别" prop="enrollmentLevel">
                  <el-select
                    style="width: 100%"
                    placeholder="请选择"
                    v-model="queryForm.enrollmentLevel"
                    clearable
                  >
                    <el-option
                      v-for="item in dict_group"
                      :key="item.dictValue"
                      :label="item.dictLabel"
                      :value="item.dictValue"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="支付状态" prop="isPay">
                  <el-select
                    style="width: 100%"
                    placeholder="请选择"
                    v-model="queryForm.isPay"
                    clearable
                  >
                    <el-option label="已支付" :value="1"></el-option>
                    <el-option label="未支付" :value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="6">
                <el-form-item label="选手身份" prop="isEngUser">
                  <el-select
                    style="width: 100%"
                    placeholder="请选择"
                    v-model="queryForm.isEngUser"
                    clearable
                  >
                    <el-option label="英文国赛晋级" :value="1"></el-option>
                    <el-option label="区域决选晋级" :value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->
              <el-col :span="6">
                <el-form-item label="学校省市区" prop="areaArray">
                  <el-cascader
                    placeholder="请选择"
                    style="width: 100%"
                    :options="areasData"
                    clearable
                    v-model="queryFormAreaArray"
                    :props="{
                      expandTrigger: 'hover',
                      checkStrictly: true,
                      label: 'name',
                      value: 'id',
                      children: 'areas',
                    }"
                    @change="selectAreaChange"
                  ></el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="学校" prop="schoolId">
                  <el-select
                    style="width: 100%"
                    placeholder="请选择"
                    v-model="queryForm.schoolId"
                    clearable
                  >
                    <el-option
                      v-for="item in provincesSchoolList"
                      :key="item.id"
                      :label="item.schoolName"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="姓名" prop="userName">
                  <el-input
                    v-model="queryForm.userName"
                    placeholder="请输入"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="手机号" prop="phone">
                  <el-input
                    v-model="queryForm.phone"
                    placeholder="请输入"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="6">
                <el-form-item label="完善详细资料" prop="isPerfect">
                  <el-select
                    style="width: 100%"
                    placeholder="请选择"
                    v-model="queryForm.isPerfect"
                    clearable
                  >
                    <el-option label="已完善" :value="1"></el-option>
                    <el-option label="未完善" :value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->
              <!-- <el-col :span="6">
                <el-form-item label="性别" prop="gender">
                  <el-select
                    placeholder="请选择"
                    style="width: 100%"
                    v-model="queryForm.gender"
                    clearable
                  >
                    <el-option
                      v-for="item in dict_gender"
                      :key="item.dictCode"
                      :label="item.dictLabel"
                      :value="item.dictValue"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->
              <!-- <el-col :span="6">
                <el-form-item label="年级" prop="grade">
                  <el-select
                    placeholder="请选择"
                    style="width: 100%"
                    v-model="queryForm.grade"
                    multiple
                    clearable
                  >
                    <el-option
                      v-for="item in dict_grade"
                      :key="item.dictCode"
                      :label="item.dictLabel"
                      :value="item.dictValue"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="班级" prop="classroom">
                  <el-select
                    placeholder="请选择"
                    style="width: 100%"
                    v-model="queryForm.classroom"
                    clearable
                  >
                    <el-option
                      v-for="item in dict_classroom"
                      :key="item.dictCode"
                      :label="item.dictLabel"
                      :value="item.dictValue"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->
              <!-- <el-col :span="6">
                <el-form-item label="赛区" prop="districtId">
                  <el-select
                    placeholder="请选择"
                    style="width: 100%"
                    v-model="queryForm.districtId"
                    clearable
                  >
                    <el-option
                      v-for="item in dict_district"
                      :key="item.districtNo"
                      :label="item.districtName"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->
              <!-- <el-col :span="6">
                <el-form-item label="支付状态" prop="nationmatchIsPayed">
                  <el-select
                    placeholder="请选择"
                    style="width: 100%"
                    v-model="queryForm.nationmatchIsPayed"
                    clearable
                  >
                    <el-option
                      v-for="item in nationmatchIsPayedList"
                      :key="item.dictCode"
                      :label="item.dictLabel"
                      :value="item.dictValue"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->
            </el-row>
          </el-form>
          <el-row :gutter="20" type="flex" justify="end">
            <el-col :span="2">
              <el-button
                type="primary"
                style="width: 100%"
                @click="searchFn"
                >查询</el-button
              >
            </el-col>
            <el-col :span="2">
              <el-button type="primary" plain style="width: 100%" @click="reset"
                >重置</el-button
              >
            </el-col>
          </el-row>
        </el-card>
        <!-- 比赛信息列表 -->
        <el-card style="margin-top: 15px">
          <el-row class="title_row" align="middle" type="flex">
            <el-col :span="12">
              <span class="title_class">选手信息列表({{ total }}人)</span>
            </el-col>
            <el-col :span="12" align="right">
              <el-button type="primary" icon="el-icon-download" plain @click="exportFn">批量导出</el-button>
            </el-col>
          </el-row>
          <!-- 国赛选手列表 -->
          <el-table
            header-cell-class-name="tableHeaderStyle"
            :data="dataList"
            border
            stripe
          >
            <el-table-column label="序号" type="index"></el-table-column>
            <el-table-column label="赛季" prop="season" width="90"></el-table-column>
            <el-table-column label="国赛编号" prop="id" width="90">
              <template slot-scope="scope"><span>NO.{{scope.row.id}}</span></template>
            </el-table-column>
            <el-table-column label="姓名" prop="userName" width="130px">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="个人信息详情" placement="top">
                  <el-link
                    style="color: #409eff"
                    @click="handleToUserDetails(scope.row.userId)"
                    >{{ scope.row.userName }}</el-link
                  >
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="学校" prop="schoolName">
              <template slot-scope="scope">
                <span
                  v-if="scope.row.fillschoolName && scope.row.fillschoolName !== ''"
                  >{{ scope.row.fillschoolName }}</span
                >
                <span v-else>{{ scope.row.schoolName }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="组别"
              prop="enrollmentLevel"
              :formatter="groupFormatter"
              width="130"
            ></el-table-column>
            <el-table-column
              label="年级"
              prop="grade"
              :formatter="gradeFormatter"
              width="70"
            ></el-table-column>
            <el-table-column label="联系方式" prop="phone"></el-table-column>
            <el-table-column label="支付状态" prop="isPay" width="100px">
              <template slot-scope="scope">
                <el-tag :type="scope.row.isPay === 1 ? 'success' : 'warning'" size="mini">{{scope.row.isPay === 1 ? '已支付' : '未支付'}}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="个人详细信息" prop="nusType" width="100px">
              <template slot-scope="scope">
                <el-tag :type="scope.row.nusType ? 'success' : 'info'" size="mini">{{scope.row.nusType ? '已完善' : '未完善'}}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="选手身份" prop="neuId" width="110px">
              <template slot-scope="scope">
                <el-tag :type="scope.row.neuId ? 'success' : ''" size="mini" effect="dark">{{scope.row.neuId ? '英文国赛晋级' : '区域决选晋级'}}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="审核阶段" prop="nationReview" width="100px">
              <template slot-scope="scope">
                <el-tag
                  :type="scope.row.nationReview === 1 ? 'success' : scope.row.nationReview === 0 ? 'danger' : 'info'"
                  size="mini"
                >
                  {{scope.row.nationReview === 1 ? '通过' : scope.row.nationReview === 0 ? '驳回' : '未审核'}}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="订单号" prop="orderNo"></el-table-column>
            <el-table-column label="创建时间" prop="createTime" width="100"></el-table-column>
            <el-table-column label="操作" width="200px">
              <template slot-scope="scope">
                <!-- <el-tooltip class="item" effect="dark" content="报名缴费信息详情" placement="top"> -->
                  <el-button
                    type="text"
                    size="small"
                    @click="getPaycostDetail(scope.row)"
                    >订单详情</el-button
                  >
                <!-- </el-tooltip> -->
                <!-- <el-tooltip class="item" effect="dark" content="修改审核状态" placement="top"> -->
                  <el-button
                    type="text"
                    size="small"
                    @click="showReviewDialog(scope.row)"
                    >修改审核状态</el-button
                  >
                <!-- </el-tooltip> -->
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryForm.pageNum"
            :page-sizes="[10, 20, 40, 80]"
            :page-size="queryForm.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </el-card>
      </el-tab-pane>
      <!-- <el-tab-pane label="第一届英文国赛选手信息" name="1">
        <spbcnUserList ref="enRef"></spbcnUserList>
      </el-tab-pane> -->
      <el-tab-pane label="区域赛晋级未缴费选手" name="2">
        <areaPromoteUserList :level="level" :districtId="districtId" ref="enRef" @updateDistrict="updateDistrictId" @updateLevel="updateLevel"></areaPromoteUserList>
      </el-tab-pane>
      <el-tab-pane label="区域赛未晋级选手" name="3">
        <!-- <areaUserList :level="level" :districtId="districtId" ref="areaRef" promotion="2" raceSchedule="4"></areaUserList> -->
        <areaUserList ref="areaRef" :districtId="districtId" @updateDistrict="updateDistrictId"></areaUserList>
      </el-tab-pane>
    </el-tabs>
    <!-- 查看缴费信息dialog -->
    <el-dialog
      title="总决选订单信息"
      :visible.sync="paymentInformationDialogVisible"
      @close="closeDiaFn"
      width="900px"
    >
      <el-collapse v-model="activeNames" @change="handleChange">
        <el-collapse-item name="1">
          <template slot="title">
            <span class="title_class title_class1">基本信息</span>
          </template>
          <el-row :gutter="24" class="content">
            <el-col :span="8">
              <span class="exam_span_class">姓名：</span>{{ userInfo.userName }}
            </el-col>
            <el-col :span="8">
              <span class="exam_span_class">性别：</span>{{userInfo.sex === "1" ? "女" : "男"}}
            </el-col>
            <el-col :span="8">
              <span class="exam_span_class">证件类型：</span>{{userInfo.cardType === '1' ? '身份证' : userInfo.cardType === '2' ? '护照' : '--'}}
            </el-col>
            <el-col :span="8">
              <span class="exam_span_class">证件号码：</span>{{userInfo.idCard}}
            </el-col>
            <el-col :span="8">
              <span class="exam_span_class">国籍：</span>{{ userInfo.nationality }}
            </el-col>
            <el-col :span="8">
              <span class="exam_span_class">学校所在地：</span>{{ userInfo.province + userInfo.city + userInfo.area}}
            </el-col>
            <el-col :span="8">
              <span class="exam_span_class">组别：</span>{{getLevelStr(userInfo.level)}}
            </el-col>
            <el-col :span="8">
              <span class="exam_span_class">年级：</span>{{getGradeStr(userInfo.grade)}}
            </el-col>
            <el-col :span="8">
              <span class="exam_span_class">学校：</span>{{ userInfo.schoolName }}
            </el-col>
            <el-col :span="8">
              <span class="exam_span_class">手机号：</span>{{userInfo.phone}}
            </el-col>
            <el-col :span="8">
              <span class="exam_span_class">邮箱：</span>{{userInfo.email}}
            </el-col>
          </el-row>
        </el-collapse-item>
        <el-collapse-item name="2">
          <template slot="title">
            <span class="title_class title_class1">详细信息</span>
          </template>
          <el-row :gutter="24" class="content" v-if="shipUserInfo.bareheadedPhoto">
            <el-col :span="24">
              <img :src="shipUserInfo.bareheadedPhoto" alt="" style="width: auto; height: auto;max-height: 100px;margin-left: 12px;">
            </el-col>
            <el-col :span="8">
              <span class="exam_span_class">英文名：</span>{{ shipUserInfo.engName }}
            </el-col>
            <el-col :span="8"><span class="exam_span_class">出生日期：</span>{{ shipUserInfo.dateBirth }}</el-col>
            <el-col :span="8"><span class="exam_span_class">年龄：</span>{{ shipUserInfo.age }}岁</el-col>
            <el-col :span="8"><span class="exam_span_class">生肖：</span>{{ shipUserInfo.chineseZodiac }}</el-col>
            <el-col :span="8"><span class="exam_span_class">星座：</span>{{ shipUserInfo.zodiac }}</el-col>
            <el-col :span="8"><span class="exam_span_class">奖品邮寄地址：</span>{{ shipUserInfo.mailAddress }}</el-col>
            <el-col :span="8"><span class="exam_span_class">父亲联系方式：</span>{{ shipUserInfo.fatherPhone }}</el-col>
            <el-col :span="16"><span class="exam_span_class">母亲联系方式：</span>{{ shipUserInfo.motherPhone }}</el-col>
            <el-col :span="8"><span class="exam_span_class">选手身高：</span>{{ shipUserInfo.heights }}</el-col>
            <el-col :span="8"><span class="exam_span_class">选手体重：</span>{{ shipUserInfo.weights }}</el-col>
            <el-col :span="24">
              <span class="exam_span_class1" v-if="shipUserInfo.parentList.length">随行家长身高体重：</span>
              <span v-for="(item, i) in shipUserInfo.parentList" :key="i">第{{ item.index }}位：{{ item.height }}/{{ item.weight }}；</span>
            </el-col>
            <el-col :span="8"><span class="exam_span_class">座右铭：</span>{{ shipUserInfo.motto }}</el-col>
            <el-col :span="8"><span class="exam_span_class1">目前对自己最难的汉字：</span>{{ shipUserInfo.hardestWord }}</el-col>
            <el-col :span="8"><span class="exam_span_class">兴趣爱好：</span>{{ shipUserInfo.hobbies }}</el-col>
            <el-col :span="8"><span class="exam_span_class">最喜欢的书籍：</span>{{ shipUserInfo.favoriteBook }}</el-col>
            <el-col :span="8"><span class="exam_span_class">最喜欢的运动：</span>{{ shipUserInfo.favoriteSport }}</el-col>
            <el-col :span="8"><span class="exam_span_class">最喜欢的学科：</span>{{ shipUserInfo.favoriteSubject }}</el-col>
            <el-col :span="24"><span class="exam_span_class1">对参加比赛其他选手的寄语：</span>{{ shipUserInfo.entryMessage }}</el-col>
            <el-col :span="24"><span class="exam_span_class1">国家级比赛对于本人的意义：</span>{{ shipUserInfo.significance }}</el-col>
            <el-col :span="24"><span class="exam_span_class1">如果你赢得了奖金，你会做什么？</span>{{ shipUserInfo.prize }}</el-col>
          </el-row>
          <div v-else style="text-align: center;">选手还未完善详细信息～</div>
        </el-collapse-item>
        <el-collapse-item name="3">
          <template slot="title">
            <span class="title_class title_class1">订单详情</span>
          </template>
          <div v-if="!nationalFees.length" style="text-align: center;">暂无订单信息～</div>
          <!-- 付费产品列表 -->
          <div v-if="paidProducts.length > 0">
            <div class="section-title">
              支付状态
              <el-tag size="mini" style="margin-left: 14px;" :type="isPay === 1 ? 'success' : 'warning'">{{ isPay === 1 ? '订单已支付' : '订单未支付' }}</el-tag>
              <el-button v-if="isPay !== 1"
                type="primary"
                size="small"
                style="margin-left: 20px;"
                @click="showuploadBill"
              >
                线下支付
              </el-button>
            </div>
            <div class="section-title" v-if="isPay === 1">支付方式<el-tag size="mini" style="margin-left: 14px;" :type="orderInfo.payType === '微信' ? 'success' : 'danger'">{{ orderInfo.payType }}</el-tag></div>
            <div v-if="nationPayFile">
              <div class="section-title">支付凭证
                <el-image
                  style="width: 100px; vertical-align: text-top;"
                  :src="nationPayFile"
                  :preview-src-list="srcList">
                </el-image>
                <div class="tip">（点击查看大图）</div>
              </div>
              <!-- <img class="nationPayFile" :src="nationPayFile" alt=""> -->
            </div>
            <div class="section-title">付费产品</div>
            <el-row>
              <el-col :span="13" v-for="(item,index) of paidProducts" :key="index">
                <div class="order-info">
                  <!-- 为52、53、54、55、56添加勾选框 -->
                  <el-checkbox
                    v-if="['52', '53', '54', '55', '56'].includes(item.productDetailId)"
                    v-model="item.checked"
                    @change="handleCheckboxChange(item, index)"
                    style="margin-right: 10px;"
                  ></el-checkbox>
                  <div class="order-left">{{ item.productName }}</div>
                  <div class="order-price" v-if="item.productDetailId === '51'">¥ {{ item.unitPrice }}</div>
                  <div class="order-price" v-if="['52', '53'].includes(item.productDetailId)">¥ {{ item.unitPrice }}</div>
                  <div class="order-price" v-if="item.productDetailId === '54'">× {{ item.productNum }}</div>
                  <div class="order-price" v-if="['55', '56'].includes(item.productDetailId)">¥ {{ item.unitPrice }} × {{ item.productNum }}</div>
                  <!-- 为54、55、56添加计数器 -->
                  <div v-if="['54', '55', '56'].includes(item.productDetailId)" class="quantity-counter">
                    <el-button
                      size="mini"
                      @click="decreaseQuantity(index)"
                      :disabled="item.productNum <= 0"
                    >-</el-button>
                    <span style="margin: 0 10px;">{{ item.productNum }}</span>
                    <el-button
                      size="mini"
                      @click="increaseQuantity(index)"
                    >+</el-button>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
          <!-- 赠送产品列表 -->
          <div v-if="giftProducts.length > 0" style="margin: 20px;">
            <el-collapse v-model="giftCollapseActive" accordion>
              <el-collapse-item name="gifts">
                <template slot="title">
                  <span class="gift-title">赠送产品 ({{ giftProducts.length }}项)</span>
                </template>
                <el-row>
                  <el-col :span="13" v-for="(item,index) of giftProducts" :key="index">
                    <div class="order-info gift-item">
                      <div class="order-left">{{ item.productName }}</div>
                      <div class="order-price gift-price">免费</div>
                    </div>
                  </el-col>
                </el-row>
              </el-collapse-item>
            </el-collapse>
          </div>
          <!-- 费用合计 -->
          <div v-if="nationalFees.length">
            <div class="total-amount-container">
              <div class="total-amount-content">
                <i class="el-icon-money" style="color: #4096ff; margin-right: 8px;"></i>
                <span class="total-amount-text">费用合计：</span>
                <!-- <span class="total-amount-value">¥ {{ orderInfo.orderAmount }}</span> -->
                <!-- <span class="total-amount-value">¥ {{ orderTotalPrice }}</span> -->
                <!-- <span class="total-amount-value">¥ {{ orderTotalPriceShow }}</span> -->
                ¥ <el-input style="width: 100px;margin-left: 8px;" v-model="orderTotalPriceShow"></el-input>

                <el-button
                  type="primary"
                  size="small"
                  @click="showEditTotalAmountDialog"
                  class="edit-total-btn"
                >
                  修改
                </el-button>
              </div>
              <div>
                <!-- <el-button v-if="isPay !== 1"
                  type="warning"
                  @click="showuploadBill"
                >
                  确认支付
                </el-button> -->
              </div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
      <span slot="footer" class="dialog-footer">
        <el-button @click="paymentInformationDialogVisible = false"
          >关闭</el-button
        >
        <el-button
          v-if="this.PayCostDetail.nationmatchIsPayed === '1'"
          type="primary"
          @click="ConfirmPayment"
          >确认支付</el-button
        >

      </span>
    </el-dialog>
    <!-- 修改审核状态弹窗 -->
    <el-dialog
      title="修改审核状态"
      :visible.sync="reviewDialogVisible"
      width="40%"
    >
      <el-form :model="reviewForm" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="姓名">
              <span>{{ reviewForm.userName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系方式">
              <span>{{ reviewForm.phone }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="学校">
          <span>{{ reviewForm.schoolName }}</span>
        </el-form-item>
        <el-form-item label="审核状态" prop="nationReview">
          <el-select v-model="reviewForm.nationReview" placeholder="请选择审核状态" style="width: 200px">
            <el-option label="未审核" :value="-1"></el-option>
            <el-option label="驳回" :value="0"></el-option>
            <el-option label="通过" :value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="reviewDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateReviewStatus">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 修改费用合计弹窗 -->
    <!-- <el-dialog
      title="修改费用合计"
      :visible.sync="editTotalAmountDialogVisible"
      width="40%"
    >
      <el-form :model="editTotalAmountForm" label-width="100px">
        <el-form-item label="费用合计">
          <el-input v-model="editTotalAmountForm.orderAmount" type="number" placeholder="请输入费用合计"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editTotalAmountDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateOrderAmount">保 存</el-button>
      </span>
    </el-dialog> -->
    <!-- 上传缴费凭证 -->
    <el-dialog
      title="上传支付凭证"
      :visible.sync="billVisible"
      @close="uploadClose"
      width="40%"
    >
      <el-alert style="margin-bottom: 30px;"
        :closable="false"
        title="上传支付凭证后，订单状态变为“已支付”。如需修改订单，仍可在订单详情中修改订单详情和订单价格。"
        type="info">
      </el-alert>
      <el-form label-width="80px">
        <el-form-item label="上传图片">
          <!-- <el-input v-model="editTotalAmountForm.orderAmount" type="number" placeholder="请输入费用合计"></el-input> -->
           <!-- :data="{
                upLoadPicUrl: uploadImgUrl,
              }" -->
           <el-upload
              class="wordImg"
              :action="this.$http.defaults.baseURL + 'upload/uploadFileAliOss'"
              :headers="headerObj"
              :show-file-list="false"
              :on-success="handleUploadSimpleImgSuccess"
              :before-upload="beforeImgUpload"
              :data="{
                  filePath: 'chineseWord/erp/finalOrder',
              }"
            >
              <img
                v-if="nationPayFile"
                :src="nationPayFile"
                class="wordImg"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="uploadClose">取 消</el-button>
        <el-button type="primary" @click="saveBillPic">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import areaJson from '@/assets/area.json'
import $common from '@/methods/common.js'
import { queryDistrictPage, getSchoolListWithCity, queryTbEnrollmentNationalList } from '@/http/api'
// import spbcnUserList from './national_english_playerInfo'
import areaPromoteUserList from './area_promote_user_list'
import areaUserList from './area_user_list_round3.vue'
export default {
  components: {
    // spbcnUserList,
    areaPromoteUserList,
    areaUserList
  },
  data () {
    return {
      orderInfo: {}, // 订单信息
      activeName: 0,
      isShowFellowTwo: false, // 是否显示随行家长第二位
      isShowFellowRelatives: false, // 是否显示随行亲属
      isSelectFellow: false, // 随行亲属是否选中
      isSelectFellowChild: false, // 随行儿童是否选中
      paycodeData: {
        remark: ''
      }, // 整体缴费数据
      fellowUnitprice: 0, // 随行人员总价（成人）
      fellowUserSelectId: [], // 随行亲属选择id
      fellowParentsSelectId: [], // 随行家长选择id
      FellowFamily: [], // 随行亲属数组
      changeTotalPriceNumber: 0, // 改变后的总价格
      Parents: [],
      changeTotalPriceDialogVisible: false,
      bigUrl: 'https://spbcn.oss-cn-zhangjiakou.aliyuncs.com/spbcnappneed/semi-finals-shareback.png',
      PayCostDetail: {
        userInfo: {},
        scoreId: ''
      },
      changeUserInfoForm: {
      },
      queryForm: {
        schoolId: '',
        pageNum: 1,
        pageSize: 10,
        raceSchedule: this.$chnEngStatusCode.raceScheduleFinal,
        phone: '',
        userName: '',
        season: this.$chnEngStatusCode.defaultSeason,
        activityType: this.$chnEngStatusCode.activityCourseType,
        isPerfect: '',
        isEngUser: '',
        isPay: ''
      },
      nowData: '',
      total: 0,
      areasData: areaJson.areas,
      queryFormAreaArray: [],
      provincesSchoolList: [],
      dataList: [],
      dict_district: [],
      dict_season: this.$userInfo.getDataList(this, 't_season').then(value => { this.dict_season = value }),
      dict_grade: this.$userInfo.getGradeData(),
      dict_gender: this.$userInfo.getDataList(this, 'e_sex').then(value => { this.dict_gender = value }),
      dict_group: this.$userInfo.dict_group(),
      dict_classroom: [],
      playerTypeList: [{
        dictCode: '0',
        dictLabel: '英文国赛选手',
        dictValue: '0'
      },
      {
        dictCode: '1',
        dictLabel: '汉英国赛选手',
        dictValue: '1'
      }],
      dict_payState: [
        {
          dictCode: 1,
          dictLabel: '未支付',
          dictValue: 0
        },
        {
          dictCode: 2,
          dictLabel: '已支付',
          dictValue: 1
        }
      ],
      nationmatchIsPayedList: [
        {
          dictCode: 0,
          dictLabel: '未支付',
          dictValue: 0
        },
        {
          dictCode: 1,
          dictLabel: '未确认支付',
          dictValue: 1
        },
        {
          dictCode: 2,
          dictLabel: '已支付',
          dictValue: 2
        }
      ],
      editScoreForm: {},
      editPaycostDialogVisible: false,
      paymentInformationDialogVisible: false,
      isPay: '', // 标记当前选择的订单是否支付
      enrollmentId: '', // 当前选择的订单id
      headerObj: {
        Authorization: localStorage.getItem('Authorization')
      },
      userInfo: {},
      activeNames: ['1', '3'],
      shipUserInfo: {},
      nationalFees: [],
      orderTotalPrice: 0, // 计算的订单总价，应付
      orderTotalPriceShow: 0, // 展示的订单总价，实付：a弹窗打开，取接口返回的价格，修改订单取计算后的价格
      reviewDialogVisible: false,
      reviewForm: {
        userId: '',
        userName: '',
        schoolName: '',
        phone: '',
        nationReview: -1
      },
      giftCollapseActive: '', // 赠送产品折叠面板状态，默认为空表示收起
      paidProducts: [], // 付费产品列表
      giftProducts: [], // 赠送产品列表
      editTotalAmountDialogVisible: false, // 修改费用合计弹窗显示状态
      editTotalAmountForm: {
        id: '',
        productNum: '',
        totalAmount: ''
      },
      billVisible: false,
      nationPayFile: '',
      srcList: [],
      level: '',
      districtId: ''
    }
  },
  created () {
    var today = new Date()
    this.nowData = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
    // this.createDictClassroom()
    this.getDistrictList()
  },
  computed: {
    $common () { return $common } // 公共方法
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    getLevelStr (level) {
      const obj = this.dict_group.find(item => item.dictCode === level)
      return obj ? obj.dictLabel : '--'
    },
    getGradeStr (grade) {
      const obj = this.dict_grade.find(item => item.dictCode === grade)
      return obj ? obj.dictLabel : '--'
    },
    handleChange (val) {
      console.log(val)
    },
    groupFormatter (data) {
      var temp = '未知'
      for (const key in this.dict_group) {
        if (Object.hasOwnProperty.call(this.dict_group, key)) {
          const element = this.dict_group[key]
          if (element.dictValue === data.enrollmentLevel + '') {
            temp = element.dictLabel
          }
        }
      }
      return temp
    },
    gradeFormatter (data) {
      var temp = '未知'
      for (const key in this.dict_grade) {
        if (Object.hasOwnProperty.call(this.dict_grade, key)) {
          const element = this.dict_grade[key]
          if (element.dictValue === data.grade + '') {
            temp = element.dictLabel
          }
        }
      }
      return temp
    },
    tabHandleClick (e) {
      console.log(e.index)
      if (e.index === '0') {
        this.getDistrictList()
      } else if (e.index === '1') {
        this.level = this.queryForm.enrollmentLevel
        this.districtId = this.queryForm.districtId
        this.$refs.enRef.getDistrictList()
      } else if (e.index === '2') {
        this.level = this.queryForm.enrollmentLevel
        this.districtId = this.queryForm.districtId
        this.$refs.areaRef.getDistrictList()
      }
    },
    updateDistrictId (id) {
      this.districtId = id
      this.queryForm.districtId = id
    },
    updateLevel (level) {
      this.level = level
      this.queryForm.enrollmentLevel = level
    },
    // 获取赛区筛选数据
    getDistrictList () {
      queryDistrictPage({ pageNum: 1, pageSize: 10000 }).then((res) => {
        this.dict_district = res.data.list
        this.searchFn()
      }).catch((err) => {
        console.log('err', err)
      })
    },
    // 创建班级数据
    createDictClassroom () {
      for (let index = 0; index < 50; index++) {
        const element = {
          dictCode: index,
          dictLabel: index + 1 + '班',
          dictValue: index + 1 + ''
        }
        this.dict_classroom.push(element)
      }
    },
    // 英文国赛选手信息
    englishNationalPlayerInfoclicked () {
      this.$router.push({
        path: '/raceManagement/individual_management/raceManagement_childview/individual_racing_schedules/national_english_playerInfo'
      })
    },
    searchFn () {
      this.queryForm.pageNum = 1
      this.getNationalPlayerInfo()
    },
    // 获取国赛选手信息信息
    getNationalPlayerInfo () {
      queryTbEnrollmentNationalList(this.queryForm).then((res) => {
        this.dataList = res.data.list
        this.total = res.data.total
      }).catch((err) => {
        console.log('err', err)
      })
    },
    // 用户点击跳转用户详情
    handleToUserDetails (userId) {
      this.$router.push({
        path: '/c_data_Management/c_player_registInfo_details',
        query: { userId }
      })
    },
    // 修改用户信息
    changeUserInfo (rowData) {
      this.changeUserInfoForm = rowData
    },
    getPaycostDetail (row) {
      this.showPayCostDialog(row)
    },
    // 查看缴费详情（获取缴费信息）
    async showPayCostDialog (item) {
      const { data } = await this.$http.get('/national/queryNationalFeesInfo', {
        params: {
          userId: item.userId,
          season: this.queryForm.season
        }
      })
      this.userInfo = data.userInfoAllVO
      this.nationalFees = data.nationalFees
      // 为52、53、54、55、56的项目添加checked属性，数量大于0时选中，否则不选中
      this.nationalFees.forEach(fee => {
        if (['52', '53', '54', '55', '56'].includes(fee.productDetailId)) {
          this.$set(fee, 'checked', fee.productNum > 0)
          // 52和53如果被选中，数量默认为1
          if (['52', '53'].includes(fee.productDetailId) && fee.productNum > 0) {
            fee.productNum = 1
          }
        }
      })
      // 分类产品：付费产品和赠送产品
      this.classifyProducts()
      if (data.shipUserInfo) {
        this.shipUserInfo = data.shipUserInfo
        data.shipUserInfo.parentList = data.shipUserInfo.parentStature ? JSON.parse(data.shipUserInfo.parentStature) : []
      } else {
        this.shipUserInfo = {}
      }
      if (data.nationalFees.length) {
        this.calculateTotalPrice(1)
      } else {
        this.getOrderDetails(item.userId, item.orderNo)
      }
      this.enrollmentId = item.id
      this.isPay = item.isPay
      this.nationPayFile = item.nationPayFile
      this.srcList[0] = item.nationPayFile
      this.paymentInformationDialogVisible = true
    },
    handleUploadSimpleImgSuccess (res, file) {
      console.log(res)
      this.nationPayFile = res.data
      this.srcList[0] = this.nationPayFile
    },
    beforeImgUpload (file) {
      const isJPGPNG = (file.type === 'image/jpeg' || file.type === 'image/png')
      const isLt2M = file.size / 1024 / 200

      if (!isJPGPNG) {
        this.$message.error('请上传图片格式')
      }
      // if (!isLt2M) {
      //   this.$message.error('上传图片大小不能超过 200KB!')
      // }
      return isJPGPNG && isLt2M
    },
    showuploadBill () {
      this.billVisible = true
    },
    saveBillPic () {
      this.$http.post('examinationUser/confirmPayV1', {
        enrollmentId: this.enrollmentId,
        nationPayFile: this.nationPayFile
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('上传成功')
          this.billVisible = false
          this.isPay = 1
          this.orderInfo.payType = '线下'
        }
      })
    },
    uploadClose () {
      if (!this.isPay) {
        this.nationPayFile = ''
        this.srcList = []
      }
      this.billVisible = false
    },
    getOrderDetails (userId, orderNo) {
      this.$http.get('/order/getTbOrderInfo', { params: { userId, orderNo } }).then(res => {
        if (res.code === 200) {
          this.orderInfo = res.data.orderInfo
          this.orderTotalPriceShow = this.orderInfo.orderAmount
          this.nationalFees = res.data.tbOrderProduct
          // 为52、53、54、55、56的项目添加checked属性，数量大于0时选中，否则不选中
          this.nationalFees.forEach(fee => {
            if (['52', '53', '54', '55', '56'].includes(fee.productDetailId)) {
              this.$set(fee, 'checked', fee.productNum > 0)
              // 52和53如果被选中，数量默认为1
              if (['52', '53'].includes(fee.productDetailId) && fee.productNum > 0) {
                fee.productNum = 1
              }
            }
          })
          // 分类产品：付费产品和赠送产品
          this.classifyProducts()
          this.calculateTotalPrice(1)
        }
      })
    },
    closeDiaFn () {
      this.activeNames = ['1', '3']
      this.getNationalPlayerInfo()
    },
    // 确认缴费点击事件
    ConfirmPayment () {
      this.paymentInformationDialogVisible = false
      this.$confirm('是否确认修改缴费信息状态?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.modifyingPayment()
      }).catch(() => { })
    },
    // 确认缴费
    async modifyingPayment () {
      var paramsData = {}
      paramsData.scoreId = this.PayCostDetail.scoreId
      const { data: res } = await this.$http.get('/match/erp/updateNationmatchPayed', {
        params: paramsData
      })
      if (res.code !== 0) {
        return this.$message.error(res.message)
      }
      this.$message.success('确认成功')
      this.getNationalPlayerInfo()
    },
    // 学校省市区选择
    selectAreaChange (value) {
      if (!value) return
      this.provincesSchoolList = []
      this.queryForm.schoolName = ''
      this.queryForm.schoolId = ''
      this.queryForm.provinceCode = value[0]
      this.queryForm.cityCode = value[1]
      this.queryForm.areaCode = value[2]
      this.getSchoolListData(value)
    },
    // 获取学校List
    getSchoolListData (schoolArea) {
      getSchoolListWithCity({ provinceCode: schoolArea[0], cityCode: schoolArea[1], areaCode: schoolArea[2] }).then((res) => {
        this.provincesSchoolList = res.data
      }).catch((err) => {
        console.log('返回的err', err)
      })
    },
    reset () {
      this.queryForm.phone = ''
      this.queryForm.userName = ''
      this.queryForm.schoolId = ''
      this.queryForm.pageNum = 1
      this.queryForm.pageSize = 10
      this.queryFormAreaArray = []
      this.provincesSchoolList = []
      this.$refs.queryFormRef.resetFields()
      this.getNationalPlayerInfo()
    },
    handleSizeChange (newSize) {
      this.queryForm.pageSize = newSize
      this.getNationalPlayerInfo()
    },
    handleCurrentChange (newCurPage) {
      this.queryForm.pageNum = newCurPage
      this.getNationalPlayerInfo()
    },
    // 修改缴费内容点击事件
    async changePaycostClicked () {
      var paramsData = {}
      paramsData.scoreId = this.PayCostDetail.scoreId
      const { data: res } = await this.$http.get('/match/erp/getNationmatchPayedDetails', {
        params: paramsData
      })
      if (res.code !== 0) {
        return this.$message.error(res.message)
      }
      for (let index = 0; index < res.data.fellowFamilys.length; index++) {
        res.data.fellowFamily[index].isSelect = '1'
      }
      for (let j = 0; j < res.data.parents.length; j++) {
        res.data.parentsList[j].isSelect = '1'
      }
      this.paycodeData = res.data
      this.changeTotalPriceNumber = Number(res.data.totalPrice)
      this.paycodeData.scoreId = this.PayCostDetail.scoreId
      this.Parents = res.data.parentsList
      this.FellowFamily = res.data.fellowFamily
      this.editPaycostDialogVisible = true
      this.createdUI()
    },
    // 初始化数据显示
    createdUI () {
      var seletParentsId = []
      var ParentsList = this.Parents
      for (let index = 0; index < ParentsList.length; index++) {
        const element = ParentsList[index]
        if (element.isSelect === '1') {
          seletParentsId.push(element.id)
        }
        if (index === 1) {
          if (element.isSelect === '1') { // 如果随行家长1是选中的 则显示随行家长2 否则不显示随行家长2 并且不显示随行亲属里面的成人亲属
            this.isShowFellowTwo = true
          } else {
            this.isShowFellowTwo = false
            this.isSelectFellow = false
            this.FellowFamily[1].isSelect = '0'
            this.paycodeData.fellowFamilyNum = '0'
          }
        }
        if (index === 2) {
          if (element.isSelect === '1') { // 如果随行家长2是选中的 则显示随行亲属 否则不显示随行亲属
            this.isSelectFellow = true
          } else {
            this.isSelectFellow = false
            this.FellowFamily[1].isSelect = '0'
            this.paycodeData.fellowFamilyNum = '0'
          }
        }
      }
      this.paycodeData.parents = seletParentsId

      var seletId = []
      var userlist = this.FellowFamily
      for (let index = 0; index < userlist.length; index++) {
        const element = userlist[index]
        if (element.isSelect === '1') { // 先统一将选中的类型添加到已选id数组里面
          seletId.push(element.id)
        }
        if (index === 0) { // 判断是否选中了随行儿童
          if (element.isSelect === '1') {
            this.isSelectFellowChild = true
          } else {
            this.isSelectFellowChild = false
          }
        }
        if (index === 1) { // 判断是否选中了随行亲属
          if (element.isSelect === '1') {
            this.isSelectFellow = true
          } else {
            this.isSelectFellow = false
          }
          this.fellowUnitprice = Number(element.price)
        }
      }
      this.paycodeData.fellowFamilys = seletId
    },
    // 随行家长点击事件
    userInfoChange (selectIndex) {
      this.Parents[selectIndex].isSelect = this.Parents[selectIndex].isSelect === '1' ? '0' : '1'
      this.createdUI()
      this.calculateTheTotalPrice()
      this.countTheRooms()
    },
    //  随行亲属选择
    fellowChange (selectIndex) {
      this.FellowFamily[selectIndex].isSelect = this.FellowFamily[selectIndex].isSelect === '1' ? '0' : '1'
      if (selectIndex === 0 && this.FellowFamily[selectIndex].isSelect === '1') {
        this.paycodeData.fellowFamilyNumChild = '1'
      }
      if (selectIndex === 0 && this.FellowFamily[selectIndex].isSelect === '0') {
        this.paycodeData.fellowFamilyNumChild = '0'
      }
      if (selectIndex === 1 && this.FellowFamily[selectIndex].isSelect === '1') {
        this.paycodeData.fellowFamilyNum = '1'
      }
      if (selectIndex === 1 && this.FellowFamily[selectIndex].isSelect === '0') {
        this.paycodeData.fellowFamilyNum = '0'
      }
      this.createdUI()
      this.calculateTheTotalPrice()
      this.countTheRooms()
    },
    // 随行人数增加点击
    increaseTap: function (type) {
      var userlist = this.FellowFamily
      if (type === 'adult') {
        if (userlist[1].isSelect === '1') {
          var fellowfamilynumber = Number(this.paycodeData.fellowFamilyNum)
          this.paycodeData.fellowFamilyNum = String(fellowfamilynumber += 1)
          this.calculateTheTotalPrice()
          this.countTheRooms()
        }
      } else {
        if (userlist[0].isSelect === '1') {
          var fellowfamilychildnumber = Number(this.paycodeData.fellowFamilyNumChild)
          this.paycodeData.fellowFamilyNumChild = String(fellowfamilychildnumber += 1)
        }
      }
    },
    // 随行人数减少点击
    reduceTap (type) {
      var userlist = this.FellowFamily
      if (type === 'adult') {
        if (userlist[1].isSelect === '1') {
          var fellowfamilynumber = Number(this.paycodeData.fellowFamilyNum)
          if (fellowfamilynumber === 1) {
            return
          }
          this.paycodeData.fellowFamilyNum = String(fellowfamilynumber -= 1)
          this.calculateTheTotalPrice()
          this.countTheRooms()
        }
      } else {
        if (userlist[0].isSelect === '1') {
          var fellowfamilychildnumber = Number(this.paycodeData.fellowFamilyNumChild)
          if (fellowfamilychildnumber === 1) {
            return
          }
          this.paycodeData.fellowFamilyNumChild = String(fellowfamilychildnumber -= 1)
        }
      }
    },
    // 根据所选内容计算总价格
    calculateTheTotalPrice () {
      // 参赛选手和家长价格计算
      var parentsTotalPrice = 0
      for (let index = 0; index < this.Parents.length; index++) {
        const element = this.Parents[index]
        if (element.isSelect === '1') {
          parentsTotalPrice += Number(element.price)
        }
      }
      // 随行亲属价格计算
      var relativesTotalfees = 0
      if (this.isSelectFellow === true) {
        relativesTotalfees += (this.fellowUnitprice * Number(this.paycodeData.fellowFamilyNum))
      }
      this.paycodeData.competitionFees = String(parentsTotalPrice + relativesTotalfees)
      // 国赛集训营
      var trainingcampfees = 0
      if (this.paycodeData.trainingCamp === '1') {
        trainingcampfees = Number(this.paycodeData.trainingCampPrice)
        trainingcampfees -= Number(this.paycodeData.codePrice)
      }
      this.paycodeData.trainingCampFees = String(trainingcampfees)
      this.paycodeData.totalPrice = String(trainingcampfees + relativesTotalfees + parentsTotalPrice)
      this.changeTotalPriceNumber = Number(this.paycodeData.totalPrice)
    },
    // 根据随行亲属人数计算房间数
    countTheRooms () {
      var roomnumber = 1
      if (this.FellowFamily[1].isSelect === '1') {
        var adultNumber = Number(this.paycodeData.fellowFamilyNum) + ((this.paycodeData.parents.length - 1) < 1 ? 0 : (this.paycodeData.parents.length - 1))
        if (adultNumber === 2) {
          roomnumber = 1
        } else {
          roomnumber = Math.floor(adultNumber / 2)
          if (adultNumber % 2 !== 0) {
            roomnumber = roomnumber + 1
          }
        }
      }
      this.paycodeData.roomNum = String(roomnumber)
    },
    // 冠军集训营点击事件
    trainingCampChange () {
      if (this.paycodeData.trainingCamp) {
        if (this.paycodeData.trainingCamp === '1') {
          this.paycodeData.trainingCamp = '0'
        } else {
          this.paycodeData.trainingCamp = '1'
        }
      } else {
        this.paycodeData.trainingCamp = '1'
      }
      this.calculateTheTotalPrice()
    },
    // 显示修改总价弹窗
    changeTotalPrice () {
      this.changeTotalPriceDialogVisible = true
    },
    // 确认修改总价格
    changeTotalClicked () {
      this.paycodeData.totalPrice = String(this.changeTotalPriceNumber)
      this.changeTotalPriceDialogVisible = false
    },
    // 修改点击事件
    changePaycodeClicked () {
      console.log(this.paycodeData)
      if (!this.paycodeData.remark || this.paycodeData.remark === '') {
        return this.$message.error('请输入修改备注信息')
      }
      this.$confirm('请再次确认是否修改?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.changeUoloadData()
      }).catch(() => { })
    },
    // 确认修改
    async changeUoloadData () {
      console.log('paycodeData', this.paycodeData)
      const { data: res } = await this.$http.post('/match/erp/updateNationmatchPayedDetails', this.paycodeData)
      if (res.code !== 0) {
        return this.$message.error(res.message)
      }
      this.editPaycostDialogVisible = false
      this.showPayCostDialog(this.PayCostDetail.scoreId)
      this.getNationalPlayerInfo()
      this.$message.success('修改成功')
    },
    exportFn () {
      const queryForms = JSON.parse(JSON.stringify(this.queryForm))
      queryForms.pageNum = 1
      queryForms.pageSize = 99999
      this.$http.get('enrollment/exportTbEnrollmentNationalList', { params: queryForms }).then(res => {
        if (res.code === 200) {
          window.open(res.data)
        }
      })
    },
    // 显示审核状态修改弹窗
    showReviewDialog (row) {
      this.reviewForm = {
        userId: row.userId,
        userName: row.userName,
        schoolName: row.fillschoolName || row.schoolName,
        phone: row.phone,
        id: row.id,
        nationReview: row.nationReview || -1
      }
      this.reviewDialogVisible = true
    },
    // 更新审核状态
    async updateReviewStatus () {
      // 第二轮
      this.$http.post('enrollment/updateNationReview', this.reviewForm).then(res => {
        if (res.code !== 200) {
          return this.$message.error(res.message)
        }
        this.reviewDialogVisible = false
        this.getNationalPlayerInfo()
        this.$message.success('审核状态修改成功')
      })
    },
    // 处理勾选框变化
    handleCheckboxChange (item, index) {
      console.log('勾选框变化:', item, index)

      // 根据产品ID设置数量
      if (['52', '53'].includes(item.productDetailId)) {
        // 52和53默认数量为1
        item.productNum = item.checked ? 1 : 0
      } else if (['54', '55', '56'].includes(item.productDetailId)) {
        // 54、55、56根据计数器数量，如果取消勾选则数量为0
        if (!item.checked) {
          item.productNum = 0
        } else if (item.productNum === 0) {
          // 如果勾选但数量为0，则设置为1
          item.productNum = 1
        }
      }

      // 重新计算总价
      this.calculateTotalPrice()
      this.orderTotalPriceShow = this.orderTotalPrice
      // 自动保存
      this.saveOrderProduct(item)
    },
    // 增加数量
    increaseQuantity (index) {
      this.nationalFees[index].productNum++
      // 如果数量从0增加到1，则自动选中
      if (this.nationalFees[index].productNum === 1) {
        this.nationalFees[index].checked = true
      }
      // 重新计算总价
      this.calculateTotalPrice()
      this.orderTotalPriceShow = this.orderTotalPrice
      // 自动保存
      this.saveOrderProduct(this.nationalFees[index])
    },
    // 减少数量
    decreaseQuantity (index) {
      if (this.nationalFees[index].productNum > 0) {
        this.nationalFees[index].productNum--
        // 如果数量减到0，则取消选中状态
        if (this.nationalFees[index].productNum === 0) {
          this.nationalFees[index].checked = false
        }
        // 重新计算总价
        this.calculateTotalPrice()
        this.orderTotalPriceShow = this.orderTotalPrice
        // 自动保存
        this.saveOrderProduct(this.nationalFees[index])
      }
    },
    // 重新计算总价格
    // type=1为打开弹窗时，只计算价格，不调保存接口
    calculateTotalPrice (type) {
      this.orderTotalPrice = 0
      this.nationalFees.forEach(item => {
        // 计算勾选的产品价格,加上国赛参赛选手(51)的价格
        if (item.checked === true || item.productDetailId === '51') {
          this.orderTotalPrice += Number(item.unitPrice) * item.productNum
        }
      })
      this.orderTotalPrice = this.orderTotalPrice.toFixed(2)

      if (type !== 1) {
        // 每次勾选保存一下
        this.editTotalAmountForm = {
          orderId: this.orderInfo.id,
          orderAmount: this.orderTotalPrice
        }
        this.updateOrderAmount()
      }
    },
    // 分类产品：付费产品和赠送产品
    classifyProducts () {
      this.paidProducts = []
      this.giftProducts = []

      this.nationalFees.forEach(item => {
        if (item.productName && item.productName.includes('赠：')) {
          this.giftProducts.push(item)
        } else {
          this.paidProducts.push(item)
        }
      })
    },
    // 显示修改费用合计弹窗
    showEditTotalAmountDialog () {
      this.editTotalAmountForm = {
        orderId: this.orderInfo.id || '',
        orderAmount: this.orderTotalPriceShow
      }
      this.$confirm('确认修改订单价格？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.editTotalAmountDialogVisible = true
        this.updateOrderAmount()
      }).catch(() => { })
    },
    // 更新订单金额
    async updateOrderAmount () {
      this.$http.post('order/updateOrderAmount', this.editTotalAmountForm).then(res => {
        if (res.code !== 200) {
          return this.$message.error(res.message)
        }
        if (this.editTotalAmountDialogVisible) {
          this.$message.success('订单价格修改成功')
        }
        this.editTotalAmountDialogVisible = false
        this.orderInfo.orderAmount = this.editTotalAmountForm.orderAmount
      }).catch(err => {
        this.$message.error('修改失败：' + err.message)
      })
    },
    // 保存订单产品信息
    async saveOrderProduct (item) {
      // 确保总价已经计算完成
      if (!this.orderTotalPrice) {
        this.calculateTotalPrice()
      }

      // 准备要保存的数据：id, productNum, totalAmount
      const saveData = {
        id: item.id,
        productNum: item.productNum,
        totalAmount: this.orderTotalPrice
      }

      try {
        const res = await this.$http.post('orderProduct/updateOrderProduct', saveData)
        if (res.code !== 200) {
          return this.$message.error(res.message)
        }
        // 静默保存，不显示成功提示，避免频繁弹窗
        console.log('产品信息更新成功')
      } catch (err) {
        this.$message.error('保存失败：' + err.message)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.input {
  margin-top: 20px;
  width: 100%;
  box-sizing: border-box;
}
.title_class1{
  font-size: 16px;
  margin-left: 12px;
  margin-right: 20px;
}
.exam_span_class {
  font-size: 14px;
  line-height: 30px;
  color: #616161;
  width: 100px;
  display: inline-block;
  text-align: right;
}
.exam_span_class1 {
  line-height: 30px;
  color: #616161;
}
.content{
  font-size: 14px;
}
.order-info{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-left: 22px;
  font-size: 14px;
  height: 42px;
  border-bottom: 1px dashed #dadada;
}
.topmenu-backview {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 60px;
  justify-content: flex-start;
}
.paycost_span_class {
  font-size: 14px;
  font-weight: 600;
  line-height: 40px;
  height: 40px;
  padding: 0px 10px;
  font-weight: 500;
  color: #616161;
}
.change_paycost_btn {
  width: 140px;
  height: 40px;
  margin-left: 20px;
}
.table_span_class {
  font-size: 8px;
  color: #616161;
}
.Title {
  font-size: 16px !important;
  color: black !important;
}
.redcolor {
  color: red;
}
.lightgreen-box {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.payment-Voucher-class {
  width: 80px;
  height: 80px;
}
.bottom-paycost-info {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.paycost-info-title {
  width: 100%;
  text-align: right;
  font-size: 16px;
  line-height: 30px;
  font-weight: 900;
}
.paycost-info-img {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.paycostinfo-lefttitle {
  font-size: 16px;
  margin-top: 10px;
  line-height: 30px;
  font-weight: 900;
}
.elformitemclass {
  margin-bottom: 0px !important;
}
.paycost-parents {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.userlist-back {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  height: 30px;
}
.userSelectimg {
  width: 20px;
  height: 20px;
}
.userlist-backview {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 40px;
}
.userSelectimg {
  width: 20px;
  height: 20px;
}

.userSelectStr {
  width: 350px;
  font-size: 16px;
  color: black;
  text-align: left;
  margin-left: 10px;
}
.userSelectStrchild {
  width: 210px;
  font-size: 16px;
  color: black;
  text-align: left;
}
.userSelectStrchildView {
  width: 240px;
  display: flex;
  flex-direction: column;
  margin-left: 20px;
}
.marageTop {
  margin-top: 20px;
}
.childStr-class {
  font-size: 12px;
}
.numberInputclasschild {
  width: 130px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.upOrDownClass {
  width: 20px;
  height: 20px;
}
.fellowNumberClass {
  font-size: 16px;
  color: black;
  text-align: center;
  padding: 0px 20px;
}
.userInfoStr {
  font-size: 16px;
  text-align: left;
  color: black;
  /* height: 60rpx;
      line-height: 60rpx; */
}
.roomNumberStr {
  font-size: 16px;
  text-align: left;
  color: black;
  text-align: right;
  font-weight: 700;
}
.homeNumberView {
  width: 80%;
  height: 25px;
  line-height: 25px;
  text-align: center;
  font-size: 16px;
  color: black;
  background-color: #fec200;
  border-radius: 12.5px;
}
.lineView {
  width: 100%;
  height: 1px;
  background-color: black;
  margin: 20px 0px;
}

.marginBottom {
  margin-bottom: 20px;
}
.couponsTitleStr {
  font-size: 16px;
  color: black;
  text-align: left;
  font-weight: 900;
}

.couponsPriceStr {
  font-size: 16px;
  font-weight: 700;
  color: black;
  text-align: right;
}
.changePriceStr {
  font-size: 12px;
  color: rgb(42, 81, 255);
  text-align: right;
  text-decoration: underline;
}
.footer-view {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}
.SelectPriceStr {
  font-size: 16px;
  font-weight: 700;
  color: black;
  text-align: center;
  position: absolute;
  right: 70px;
}
.redcolor {
  color: red;
  font-size: 20px;
}
/deep/ input::-webkit-outer-spin-button,
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
/deep/ input[type="number"] {
  -moz-appearance: textfield !important;
}
.div_algin_right {
  text-align: right;
}

::v-deep .el-tabs--card>.el-tabs__header{
  background: #fff;
  margin-bottom: 0;
  border-bottom: none;
  border-top-left-radius: 4px;
}

.quantity-counter {
  display: flex;
  align-items: center;
  margin-left: 10px;
}

.order-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-left: 22px;
  font-size: 14px;
  height: 42px;
  border-bottom: 1px dashed #dadada;
}

.section-title {
  font-size: 14px;
  font-weight: bold;
  color: #4096ff;
  padding-left: 22px;
  margin: 10px 0;
}
.tip{
  color: #9a9999;
  font-size: 12px;
  font-weight: normal;
  margin-left: 62px;
}
.gift-title {
  font-size: 14px;
  font-weight: bold;
  color: #4096ff;
}

.gift-item {
  background-color: #f0f9ff;
  padding: 0px 30px;
}

.gift-price {
  color: #67c23a;
  font-weight: bold;
}

.total-amount-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 24px;
  padding: 16px 20px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  // border-radius: 8px;
  // border: 1px solid #dee2e6;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.total-amount-content {
  display: flex;
  align-items: center;
  font-size: 18px;
}

.total-amount-text {
  color: #495057;
  font-weight: 500;
  margin-right: 8px;
}

.total-amount-value {
  color: #409eff;
  font-weight: bold;
  font-size: 20px;
}

.edit-total-btn {
  background: linear-gradient(135deg, #409eff 0%, #36a3f7 100%);
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  transition: all 0.3s ease;
  margin-left: 20px;
}

.edit-total-btn:hover {
  background: linear-gradient(135deg, #36a3f7 0%, #2d8cf0 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(64, 158, 255, 0.3);
}
.wordImg {
  width: 100px;
  height: 100px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border: 1px dashed #a8b1bd;
  border-radius: 4px;
}
.nationPayFile{
  max-width: 400px;
}
</style>
